<template>
  <div class="pc-course-series">
    <div class="pc-course-series-header">
      <h2>报名字段设置</h2>
      <div class="pc-button-group">
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <div class="checkBox" v-for="item in competitionList" :key="item.id">
      <div>
        <div class="checkBox1">
          <el-checkbox
            :disabled="!isEditting"
            :label="item.chinese_name"
            :true-label="1"
            :false-label="0"
            v-model="item.config"
          ></el-checkbox>
        </div>
        <div class="checkBox1">
          <el-switch
            :disabled="!isEditting || !item.config"
            v-model="item.required"
            active-text="必填"
            inactive-text="非必填"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  competitionField_Api,
  getCompetitionField_Api,
  createCompetitionField_Api,
} from "../../../../apis/competition.api";
export default {
  props: ["competitionDetail"],
  data() {
    return {
      isEditting: false,
      isUpdateShow: false,
      competitionList: [],
      competitionContent: {
        competition_id: null,
        field_obj_list: [],
      },
      required: 0,
      competitionConfig: null,
    };
  },

  async mounted() {
    await this.getCompetitionFieldList();
  },
  methods: {
    getCompetitionFieldConfig() {
      getCompetitionField_Api(this.$route.query.id).then((res) => {
        this.competitionConfig = res.data;
        this.dataMatch();
      });
    },
    dataMatch() {
      this.competitionConfig.forEach((item) => {
        this.competitionList.forEach((item2) => {
          if (item.field_english_name == item2.english_name) {
            this.$set(item2, "config", 1);
            this.$set(item2, "required", item.required);
          }
        });
      });
    },

    getCompetitionFieldList() {
      if (this.$global.getLocalData("competition_config")) {
        this.competitionList = this.$global.getLocalData("competition_config");
        this.getCompetitionFieldConfig();
      } else {
        competitionField_Api().then((res) => {
          this.competitionList = res.data;
          console.log(this.competitionList)
          this.$global.setLocalData("competition_config", this.competitionList);
          this.getCompetitionFieldConfig();
        });
      }
    },

    manageSeries() {
      this.isEditting = true;
    },
    save() {
      console.log(this.competitionList);
      let field_obj_list = [];
      this.competitionList.forEach((item) => {
        if (item.config == 1) {
          field_obj_list.push({
            field_id: item.id,
            required: item.required ? item.required : 0,
          });
        }
      });
      this.competitionContent.competition_id = +this.$route.query.id;
      this.competitionContent.field_obj_list = field_obj_list;
      console.log(field_obj_list);
      createCompetitionField_Api(this.competitionContent).then((res) => {
        // this.getCompetitionFieldConfig();
        this.$global.success(this, "修改成功");
        this.isEditting = false;
      });
    },
  },
};
</script>

<style scoped lang='scss'>
/deep/ .el-switch__label.is-active {
  color: $lightenYellow;
}
/deep/.el-checkbox:last-of-type {
  margin-right: 20px;
}
.pc-course-series {
  @include box-model;
  .checkBox {
    display: inline-block;
    width: 50%;
    height: 20px;
    margin-top: 30px;
    div {
      display: flex;
      margin-right: 20px;
      width: 100%;
      .checkBox1 {
        width: 80%;
      }
    }
    div:nth-of-type(2n) {
      margin-right: 0px;
    }
  }
  .pc-course-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
    }
  }

  .series-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    height: 180px;
    overflow: hidden;
    .pc-btn {
      @include manage-button;
    }
    .addbtn {
      width: 170px;
      height: 58px;
      color: $blueBtna;
      background: white;
      border: 1px dashed rgb(105, 129, 205);
      border-radius: 4px;
    }
    .series-item {
      width: 16%;
      margin-right: 0.6%;
      height: 60px;
      border-radius: 4px;
      border: 1px solid rgb(105, 129, 205);
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      cursor: pointer;
      position: relative;
      .series-item-content {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 100%;
        width: 100%;
        margin: 0;

        .nameBox {
          width: 90px;
          margin: 10px 10px 0 0;
          .name {
            @include ellipsis;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            color: rgb(105, 129, 205);
            line-height: 14px;
          }
        }
        .lineBox {
          background: #dad6d6;
          height: 60%;
          width: 1.5px;
        }
        .numberBox {
          width: 30%;
          height: 100%;
          .number {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            font-size: 15px;

            align-items: center;
            span:nth-child(1) {
              display: inline-block;
              font-size: 16px;
              margin-right: 2px;
              height: 14px;
              line-height: 14px;
              color: $lightenYellow;
            }
            span:nth-child(2) {
              font-size: 11px;
              margin-top: 5px;
              display: inline-block;
              height: 14px;
              line-height: 14px;
              color: #c0c0c0;
            }
          }
        }
      }
      .choice {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 0px 4px 4px 0;
        // background:rgba($color: #000000, $alpha: 0.4);
        .choice-delete:nth-child(1) {
          display: none;
        }
        //   /deep/ .el-icon-edit:hover {
        //     color: $lightenYellow;
        //   }
        // }
        .choice-delete:nth-child(2) {
          display: none;
        }
        //   /deep/ .el-icon-circle-close:hover {
        //     color: $lightenYellow;
        //   }
        // }
      }
      .choice:hover {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 0px 4px 4px 0;
        background: rgba($color: #000000, $alpha: 0.4);
        .choice-delete:nth-child(1) {
          display: block;
          width: 20%;
          height: 20%;
          display: flex;
          justify-content: center;
          border-radius: 0px 4px 4px 0;
          /deep/ .el-icon-edit {
            font-size: 20px;
            color: white;
          }
          /deep/ .el-icon-edit:hover {
            color: $lightenYellow;
          }
        }
        .choice-delete:nth-child(2) {
          display: block;
          width: 20%;
          height: 20%;
          display: flex;
          justify-content: center;
          border-radius: 0px 4px 4px 0;
          /deep/ .el-icon-circle-close {
            font-size: 20px;
            color: white;
          }
          /deep/ .el-icon-circle-close:hover {
            color: $lightenYellow;
          }
        }
      }
    }
    .active:hover {
      transform: translateY(-20px);
      transition: 0.6s;
    }
    .lost {
      opacity: 0.44;
      position: relative;
      overflow: hidden;
      .lost-icon {
        position: absolute;
        width: 60px;
        top: 6px;
        left: -16px;
        text-align: center;
        background: $blueBtna;
        font-size: 10px;
        font-weight: 400;
        color: $base-color;
        transform: rotate(-45deg);
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    li {
      cursor: pointer;
      width: 34px;
      height: 5px;
      background: $schoolTagBorder;
      margin-right: 10px;
    }
    .choicePage {
      background: $blueBtna;
    }
  }
  /deep/ .el-dialog__footer {
    .dialog-footer-button-one {
      @include manage-button;
      background: $test;
      color: $blueBtna;
    }
    .dialog-footer-button-second {
      @include manage-button;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionField.vue